import React from "react";
import NewButton from "./NewButton";
import "./PopUpModal.css";
import { ReactComponent as Close } from "../assets/icons/x.svg";
import { ReactComponent as EMPTYSTAR } from "../assets/icons/empty-star.svg";
import { FormTextArea } from "../Components/FormTextArea";
import { useEnterKey } from "../Hooks/useEnterKey";

const PopUpModal = ({ components, children, title, deleteBtn, subText, text, btnText, backBtnText, sendIcon, disableBtn, onClick = () => { },
  onBackClick = () => { }, onClose = () => { }, showClose = false, iconBgColor = "#e6faf2", warningText, hideIcon = false, alignLeft,
  showReview = false, reviewRating, setReviewRating, reviewText, setReviewText,contentFullWidth = false , customGap}) => {

  useEnterKey(() => onClick());
    
  return (
    <div className="newPopUpModalWrap">
      <div className="newPopUpModalContainer" style={{ alignItems: alignLeft ? "flex-start" : "center" }}>
        <h2 className="newPopUpModalTitle">{title}</h2>
        <div className={`newPopUpModalContent ${contentFullWidth ? "w-full" : ""} ${customGap ? customGap : ""}`}>
          {!hideIcon && <div className="newPopUpModalIcon" style={{ background: iconBgColor }}>{children}</div>}
         {(text || subText) && <div className="newPopUpModalTextWrap">
            {subText && <p className="newPopUpModalSubText" style={{ textAlign: alignLeft ? "left" : "center" }}>
              {subText}
            </p>}
           {text && <p className="newPopUpModalText" style={{ textAlign: alignLeft ? "left" : "center" }}>
              {text}
            </p>}
          </div>}
          {warningText && <div className="newPopUpModalWarning">{warningText}</div>}

          {components && components}

          {showReview && <div className="accSingleOrderReviewWrap" style={{ marginTop: 0 }}>
            {<p className="accSingleInvoiceText">How did we do?</p>}
            <div className="accSingleOrderStarWrap">
              <EMPTYSTAR className={`accSingleOrderStar ${reviewRating > 0 ? "accSingleOrderStarSelected" : ""}`} onMouseOver={() => setReviewRating(1)} onClick={() => setReviewRating(1)} />
              <EMPTYSTAR className={`accSingleOrderStar ${reviewRating > 1 ? "accSingleOrderStarSelected" : ""}`} onMouseOver={() => setReviewRating(2)} onClick={() => setReviewRating(2)} />
              <EMPTYSTAR className={`accSingleOrderStar ${reviewRating > 2 ? "accSingleOrderStarSelected" : ""}`} onMouseOver={() => setReviewRating(3)} onClick={() => setReviewRating(3)} />
              <EMPTYSTAR className={`accSingleOrderStar ${reviewRating > 3 ? "accSingleOrderStarSelected" : ""}`} onMouseOver={() => setReviewRating(4)} onClick={() => setReviewRating(4)} />
              <EMPTYSTAR className={`accSingleOrderStar ${reviewRating > 4 ? "accSingleOrderStarSelected" : ""}`} onMouseOver={() => setReviewRating(5)} onClick={() => setReviewRating(5)} />
            </div>
            <FormTextArea placeholder="Review (optional)" value={reviewText} onChange={setReviewText} />
          </div>}
        </div>
        <div className="newPopUpModalTextWrap">
          {btnText && <NewButton disabled={disableBtn} text={btnText} width="100%" onClick={onClick} deleteBtn={deleteBtn} />}
          {backBtnText && <NewButton text={backBtnText} width="100%" onClick={onBackClick} back sendIcon={sendIcon} icon={false} whiteBtn />}
        </div>
        {showClose && <Close className="newPopUpModalCloseIcon" onClick={onClose} />}
      </div>
    </div>
  );
};

export default PopUpModal;
